export var ConditionalColoringOperator = /*#__PURE__*/ function(ConditionalColoringOperator) {
    ConditionalColoringOperator["Eq"] = "equalTo";
    ConditionalColoringOperator["NtEqTo"] = "notEqualTo";
    ConditionalColoringOperator["Gt"] = "greaterThan";
    ConditionalColoringOperator["Lt"] = "lessThan";
    ConditionalColoringOperator["GtEqTo"] = "greaterThanEqualTo";
    ConditionalColoringOperator["LtEqTo"] = "lessThanEqualTo";
    ConditionalColoringOperator["Between"] = "isBetween";
    ConditionalColoringOperator["Contains"] = "contains";
    ConditionalColoringOperator["DoesNotContain"] = "doesNotContain";
    ConditionalColoringOperator["AssignedTo"] = "assignedTo";
    ConditionalColoringOperator["NotAssignedTo"] = "notAssignedTo";
    ConditionalColoringOperator["Empty"] = "empty";
    return ConditionalColoringOperator;
}({});
